module.exports = __webpack_public_path__ + "img/bike1.75ed391d.svg";